import { Swagpack } from "../models/Swagstore/Packs";
import { OrderMockup } from "../models/Order/OrderMockup";

const PLACEHOLDER =
    "https://content.swageazy.com/blogs/Vector-(1)_1742630924118.png";

const isApproved = (value: boolean | number | undefined): boolean =>
    value === 1 || value === true;

const isShownOnStore = (mockup: OrderMockup): boolean => {
    if (!mockup?.image_url) return false;
    if (!isApproved(mockup.approved)) return false;
    if (mockup.active === false) return false;
    if (isApproved(mockup.is_rejected)) return false;
    return true;
};

const catalogProductImage = (pack: Swagpack): string => {
    const fromProduct = (pack.products ?? [])
        .flatMap((product) => product.images ?? [])
        .map((url) => String(url ?? "").trim())
        .find(Boolean);
    if (fromProduct) return fromProduct;
    const packImage = String(pack.pack_image_url ?? "").trim();
    if (packImage && packImage !== PLACEHOLDER) return packImage;
    return "";
};

/**
 * Setup and admin preview image.
 * Approved mockup first. Swageazy product photo until that mockup exists.
 */
export const getPackDisplayImage = (
    pack: Swagpack,
    fallbackImage?: string
): string => {
    const defaultPlaceholder = fallbackImage || PLACEHOLDER;
    const mockups = (pack.products ?? []).flatMap(
        (product) => product.mockups ?? []
    );
    const visible = mockups.filter(isShownOnStore);
    const primary = visible.find((mockup) => mockup.priority === 1);
    return (
        primary?.image_url ||
        visible[0]?.image_url ||
        catalogProductImage(pack) ||
        defaultPlaceholder
    );
};
